var angular = require('angular')

angular.module('AemBranchesAppointments')
  .component('appointmentSelectTime', {
    template: require('./appointment-select-time.component.tpl.html'),
    controller: AppointmentSelectTimeCtrl,
    controllerAs: 'vm',
    bindings: {
      timeslots: '<',
      onClose: '&'
    }
  })

AppointmentSelectTimeCtrl.$inject = ['$timeout', '$routeParams', '$location', 'userTracking']

function AppointmentSelectTimeCtrl ($timeout, $routeParams, $location, userTracking) {
  var vm = this

  vm.$onInit = function () {
    vm.close = close
    vm.select = select
  }

  function close () {
    $timeout(vm.onClose)
  }

  function select (timeslot) {
    userTracking.onClick('selectTime')
    $timeout(vm.onClose)
    $location.path('/branch/' + $routeParams.branchId + '/timeslot/' + timeslot.date.getTime())
  }
}
